<template>
  <div>
    <el-tabs v-model="activeTab" @tab-click="changeTab">
      <el-tab-pane v-for="(item,tabIndex) in data" :label="item.label" :name="item.name" :key="tabIndex">
        <span slot="label" v-if="item.showBadge">
          <el-badge style="margin-top: 10px;margin-bottom: 10px" :value="pageTotal[item.name] === 0 ? '':pageTotal[item.name]"
            :max="99">{{item.label}}</el-badge>
        </span>
      </el-tab-pane>
    </el-tabs>
    <w-table :columns="columns" :table-data="tableData" @rowSelection="rowSelection($event)"
      @getTableSearchSortCon="(...event) => { getTableSearchSortCon(event) }" :isPagination="true" :key="activeTab"
      :table-col-check="{isShow:true,name:'RecordCheck2' + activeTab}" ref="wMyTable" :page="page"
      @pageChange="handlePagePagination($event, page)" :isShowRowSelection="true">
      <div slot="operation" slot-scope="{text,record}">
        <el-button size="mini" type="success" v-if="record.status !== 'APPLYING' || isAuditViewOnly"
          @click="handleDetails(record)">查看详情</el-button>
        <el-button size="mini" type="primary" v-if="record.status === 'APPLYING' && !isAuditViewOnly"
          @click="handleEdit(record)">审核</el-button>
        <el-button size="mini" type="warning" v-if="record['annex']" @click="download(record)">下载试剂清单</el-button>
      </div>
      <div slot="contactName" style="display:flex" slot-scope="{text,record,index}">
        <ex-fold-table-cell :scope="{text:[...new Set(text)], record, index}"></ex-fold-table-cell>
      </div>
      <div slot="invoiceTitle" slot-scope="{text,record,index}">
        <ex-fold-table-cell :scope="{text:[...new Set(text)], record, index}"></ex-fold-table-cell>
      </div>
      <div slot="filterFlag" slot-scope="{ setSelectedKeys, selectedKeys, confirm, column,clearFilters }"
        style="padding: 8px; position: relative; z-index: 9999 !important;">
        <div style="padding: 15px 15px 0">
          <el-radio-group v-model="selectedKeys[0]">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-radio label='是'>是</el-radio>
              </el-col>
              <el-col :span="12">
                <el-radio label='否'>否</el-radio>
              </el-col>
            </el-row>
          </el-radio-group>
        </div>
        <div style="display: flex;padding: 15px">
          <a-button type="primary" icon="search" size="small" style="width: 90px; margin-right: 8px"
            @click="() => handleSearch(setSelectedKeys,selectedKeys, confirm, column,clearFilters)">搜索
          </a-button>
          <a-button size="small" style="width: 90px" @click="() => handleReset( column,clearFilters)">取消
          </a-button>
        </div>
      </div>
      <div slot="filterStatus" slot-scope="{setSelectedKeys,selectedKeys, confirm, column,clearFilters}"
        style="padding: 8px; position: relative; z-index: 9999 !important;">
        <div style="padding: 15px 15px 0">
          <el-radio-group v-model="selectedKeys[0]">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-radio label='待审核'>待审核</el-radio>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-radio label='已通过'>已通过</el-radio>
              </el-col>
              <el-col :span="12">
                <el-radio label='已驳回'>已驳回</el-radio>
              </el-col>
            </el-row>
          </el-radio-group>
        </div>
        <div style="display: flex;padding: 15px">
          <a-button type="primary" icon="search" size="small" style="width: 90px; margin-right: 8px"
            @click="() => handleSearch(setSelectedKeys,selectedKeys, confirm, column,clearFilters)">搜索
          </a-button>
          <a-button size="small" style="width: 90px" @click="() => handleReset( column,clearFilters)">取消
          </a-button>
        </div>
      </div>
      <div slot="contractNumbers" slot-scope="{text,record,index}">
        <ex-fold-table-cell v-if="text" :scope="{text, record, index}"></ex-fold-table-cell>
      </div>
      <div slot="status" slot-scope="{text,record}">
        <span style="display: flex;align-items: center">
          <el-tag :type="getStatusColor(text,'tagType')"
            :style="{color: getStatusColor(text,'color'),'background-color':getStatusColor(text,'backgroundColor')}">
            {{getStatusColor(text,'name')}}</el-tag>
          <w-ellipsis-and-look v-if="text === 'DEFEAT'" style="margin-left:5px" class="w-ellipsis-and-look"
            :text="record['rejectionReason']" :column="{title:'驳回原因'}" :onlyDetail="true" :isOpenHtml="false">
          </w-ellipsis-and-look>
        </span>
      </div>
      <div slot="connectedFlag" slot-scope="{text,record}">
        <div v-if="record['requestNumberOfInvoices']>1">
          <el-tag v-if="text === 1" type="success">是</el-tag>
          <el-tag v-else-if="text === 0" type="danger">否</el-tag>
          <el-tag v-else type="primary">未知状态</el-tag>
        </div>
        <div v-else>
          <el-tag type="info">NA</el-tag>
        </div>
      </div>
      <div slot="sameDayFlag" slot-scope="{text,record}">
        <div v-if="record['requestNumberOfInvoices']>1">
          <el-tag v-if="text === 1" type="success">是</el-tag>
          <el-tag v-else-if="text === 0" type="danger">否</el-tag>
          <el-tag v-else type="primary">未知状态</el-tag>
        </div>
        <div v-else>
          <el-tag type="info">NA</el-tag>
        </div>
      </div>
    </w-table>
    <picture-loading v-if="loading"></picture-loading>
    <details-audit-dialog v-if="showCheckDialog" :show-dialog="showCheckDialog" :record-detail="recordDetail"
      :contract-detail="contractDetail" :analysis-flag="false" @submit="closeCheckDialog"></details-audit-dialog>
    <record-details v-if="showDetailsDialog" :show-dialog="showDetailsDialog" :select-detail="showDetails"
      @submit="close"></record-details>
    <customer-user-info :show-dialog="showContactInfo" v-if="showContactInfo" :select-detail="contactInfo"
      @submit="closeShowContact"></customer-user-info>
  </div>
</template>

<script>
import TableHeadNote from "@/components/customerTable/TableHeadNote.vue";
import ExFoldTable from "@/components/ExFoldTable.vue";
import ExFoldCell from "@/components/ExFoldCell.vue";
import {recordChecks} from "@/utils/data/tableCol/check/record/recordChecks";
import {downloadRecord, getRecordPage} from "@/api/dilivery/record";
import RecordDetails from "@/components/record/RecordDetails.vue";
import {getContractPage} from "@/api/dilivery/sales/contract";
import DetailsAuditDialog from "@/components/check/DetailsAuditDialog.vue";
import ExFoldTableCell from "@/components/ExFoldTableCell.vue";
import {tableOperationMixin} from "@/mixins/tableOperation";
import PictureLoading from "@/components/customerTable/PictureLoading.vue";
import _ from "lodash";
import {viewDetailIcon} from "@/utils/icon";
import CustomerUserInfo from "@/components/customer/CustomerUserInfo.vue";
import {getUserPage} from "@/api/dilivery/customer/user";
import {getStatusColor} from "../../../color";
import { getDataInLocalStorage } from "@/utils/localStorage";
import { auditViewOnlyMixin } from "@/mixins/auditViewOnlyMixin";
const baseURL = process.env.VUE_APP_BASE_API


export default {
  name: "RecordCheck",
  components: {
    CustomerUserInfo,
    PictureLoading, DetailsAuditDialog, RecordDetails, ExFoldCell, ExFoldTable, TableHeadNote,ExFoldTableCell},
  mixins: [tableOperationMixin, auditViewOnlyMixin],
  data() {
    return {
      tableData: [],
      selectable: [],
      searchConditionTag: [],
      sortConditionTag: [],
      page: { pageSize: 10, currentNum: 1, total: null },
      data: [
        { label: '全部', name: 'ALL', showBadge: false },
        { label: '待审核', name: 'APPLYING', showBadge: true },
        { label: '已通过', name: 'SUCCESS', showBadge: false },
        { label: '已驳回', name: 'DEFEAT', showBadge: false },
      ],
      sendData: {
        ALL: {},
        APPLYING: { "query#status.EQ": "APPLYING" },
        SUCCESS: { "query#status.EQ": "SUCCESS" },
        DEFEAT: { "query#status.EQ": "DEFEAT" },
      },
      pageTotal: { ALL: 0, APPLYING: 0, SUCCESS: 0, DEFEAT: 0 },
      activeTab: 'APPLYING',
      loading: true,
      viewDetailIcon: viewDetailIcon,
      contactInfo: [],
      showContactInfo: false,
      showCheckDialog: false,
      recordDetail: {},
      contractDetail: {},
      showDetailsDialog: false,
      showDetails: '',
    }
  },
  computed: {
    columns() {
      let keys = ['operatingPersonName','operatingTime']
      let cols = recordChecks([] || {})
      if(this.activeTab === "APPLYING"){
        cols = cols.filter(item => !keys.includes(item.key))
      }
      return JSON.parse(JSON.stringify(cols))
    },
  },
  mounted() {
    this.loadAllTabTotals()
    this.getData()
  },
  methods: {
    getStatusColor,
    getTableSearchSortCon(ConditionTag) {
      this.searchConditionTag = ConditionTag[0]
      this.sortConditionTag = ConditionTag[1]
      this.getData('search')
    },
    handlePagePagination(page) {
      this.page.currentNum = page.currentNum
      this.page.pageSize = page.pageSize
      this.getData()
    },
    loadAllTabTotals() {
      // 销售侧角色（SALES_MANAGER、SALES）仅查看详情，不发起标签页红点数量查询
      if (this.isAuditViewOnly) return
      Object.keys(this.sendData).forEach(tabName => {
        let sendData = { ...this.sendData[tabName] }
        getRecordPage({ 'page.current': 1, 'page.size': 1 }, sendData).then(res => {
          if (res.code === 200) {
            this.$set(this.pageTotal, tabName, parseInt(res.data.total))
          }
        })
      })
    },
    async download(row) {
      try {
        let url = `${baseURL}/invoice-record/attachment/${row.id}?Authorization=${getDataInLocalStorage("token")}&Current-Role=${getDataInLocalStorage("role")}`
        const elink = document.createElement('a')
        elink.href = url
        document.body.appendChild(elink)
        elink.click()
        document.body.removeChild(elink);
      } catch (error) {
        console.log(error);
      }
    },
    changeTab() {
      this.$nextTick(() => {
        this.tableData = []
        this.selectable = []
        this.searchConditionTag = []
        this.sortConditionTag = []
        this.page = { pageSize: 10, currentNum: 1, total: null }
        if (this.$refs.wMyTable) {
          this.$refs.wMyTable.selectedRowKeys = []
          this.$refs.wMyTable.searchConditionTag = []
        }
        this.getData()
      })
    },
    closeShowContact() {
      this.showContactInfo = false
    },
    showContact(contactName) {
      let data = {
        "query#contactName.IN": contactName.join(',')
      }
      getUserPage({}, data).then(res => {
        if (res.code === 200) {
          this.contactInfo = res.data.records
          this.showContactInfo = true
        } else {
          this.showContactInfo = false
        }
      }).catch(err => {
        this.showContactInfo = false
      })
    },
    rowSelection(selectedRows) {
      this.selectable = _.unionBy(this.selectable, selectedRows, 'id').filter(item => this.$refs.wMyTable.selectedRowKeys.includes(item.id));
    },
    getData(searchFlag) {
      this.loading = true
      let params = {
        'page.current': this.page.currentNum,
        'page.size': this.page.pageSize,
      }
      if (searchFlag) {
        params = { 'page.current': 1, 'page.size': 10 }
      }
      if (this.sortConditionTag && this.sortConditionTag.length > 0) {
        params["order"] = this.sortConditionTag.map(sortCondition => {
          return sortCondition.colName + "." + sortCondition.order;
        }).join(",");
      }
      let sendData = { ...this.sendData[this.activeTab] }
      if (this.searchConditionTag && this.searchConditionTag.length) {
        sendData = this.getSearch(sendData)
      }
      getRecordPage(params, sendData).then(res => {
        this.loading = false
        if (res.code === 200) {
          this.tableData = res.data.records
          this.page.currentNum = parseInt(res.data.current)
          this.page.pageSize = parseInt(res.data.size)
          this.page.total = parseInt(res.data.total)
          // 销售侧角色不展示标签页红点数量
          if (!this.isAuditViewOnly) {
              this.$set(this.pageTotal, this.activeTab, parseInt(res.data.total))
          }
        }
      }).catch(error => {
        this.loading = false
      })
    },
    getSearch(sendData) {
      
      this.searchConditionTag.forEach(item => {
        let value = item.value
        if (item.key === 'status') {
          if (item.value === '待审核') {
            value = 'APPLYING'
          } else if (item.value === '已通过') {
            value = 'SUCCESS'
          } else {
            value = 'DEFEAT'
          }
        } else if (['connectedFlag','sameDayFlag'].includes(item.key)) {
          if (item.value === '是') {
            value = 1
          } else {
            value = 0
          }
        } else if (item.key === 'contractNumber') {
          value = value.replace(/[A-Za-z]/g, "")
        }
        if (['contractNumber','saleName','invoiceTitle','contactName'].includes(item.key)) {
          sendData[item.key] = value
        } else {
          sendData["query#" + item.key + ".LIKE"] = value
        }
      })
      return sendData
    },
    async handleEdit(row) {
      try {
        const res = await getRecordPage({}, { "query#id.EQ": row.id })
        if (res.code === 200 && res.data.records.length > 0) {
          if (res.data.records[0].status !== 'APPLYING') {
            this.$messageUi.error('该发票已审核')
            this.getData(true)
            return
          }
          this.recordDetail = res.data.records[0]
        } else {
          this.recordDetail = {}
          this.$messageUi.error('发票数据获取失败')
          return
        }
        let data = {
          "query#contractNumber.IN": row.contractNumbers.join(','),
          "query#status.EQ": "APPLYING"
        }
        const response = await getContractPage({}, data)
        if (response.code === 200) {
          this.contractDetail = response.data.records[0]
        } else {
          this.contractDetail = {}
        }
        this.showCheckDialog = true
      } catch (error) {
        console.log(error);
        this.showCheckDialog = false
        this.$messageUi.error('打开审核页面失败')
      }
    },
    handleDetails(row) {
      this.showDetails = row
      this.showDetailsDialog = true
    },
    closeCheckDialog(type) {
      if (type === 'confirm') {
        this.getData()
      }
      this.$nextTick(() => {
        this.showCheckDialog = false
      })
      this.recordDetail = {}
      this.contractDetail = {}
    },
    close() {
      this.$nextTick(() => {
        this.showDetailsDialog = false
      })
    }
  }
}
</script>

<style scoped>
.status-tag-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}
</style>
